/**
 * Created by mac on 9/25/20
 */

const EpisodeStatistics = function () {
    DataSource.call(this);
};

EpisodeStatistics.prototype = Object.create(DataSource.prototype);
EpisodeStatistics.prototype.constructor = EpisodeStatistics;

EpisodeStatistics.getStatisticsUrl = function (params) {
    const language = cleverapps.administrator.adminEpisodes.getEpisodesLanguage();
    return `/admin/episodestatistics/versions?${cleverapps.toUrlHash(language ? { ...params, language } : params)}`;
};

EpisodeStatistics.prototype.calculateData = function (adminEpisode, f) {
    const episodeNo = adminEpisode.episodeNo;

    if (cleverapps.config.type === "merge") {
        return;
    }

    const activeVersions = cleverapps.administrator.adminLevels.getActiveVersions();

    cleverapps.RestClient.get(EpisodeStatistics.getStatisticsUrl({ episode: episodeNo }), {}, (data) => {
        this.data = data.filter((line) => line.version === activeVersions[line.level])
            .map((line) => {
                line.levelNo = line.level;
                line.difficulty = Math.round(line.difficulty);
                line.hints = Math.round(line.hints);

                return line;
            });

        // console.log("Response episode: ", this.data);
        if (this.data) {
            let totalMinutes = 0;
            this.data.forEach((item) => {
                totalMinutes += item.minutes;
            });
            console.log(`To complete episode ${adminEpisode.episodeNo} the player needs ${totalMinutes} minutes.`);
        }

        f();
    }, () => {
        console.log("Error getting statistics for episode", adminEpisode);
    });
};
